import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';
import {
	type IAttributeVocabularyValue,
	type AttributeVocabularyValueSort,
} from '../schema';

/**
 * `setAttributeVocabularyValuesOrder` request params
 * (what is used to send to server)
 */

export type SetAttributeVocabularyValuesOrderRequestOptions = {
	vocabularyId: number;
	sort: AttributeVocabularyValueSort;
};

/**
 * `setAttributeVocabularyValuesOrder` request
 * (what sets sent to the server)
 */
export type SetAttributeVocabularyValuesOrderRequest = [
	SetAttributeVocabularyValuesOrderRequestOptions['vocabularyId'],
	SetAttributeVocabularyValuesOrderRequestOptions['sort'],
];

/**
 * `setAttributeVocabularyValuesOrder` response
 * (what comes back from the server)
 */
export type SetAttributeVocabularyValuesOrderResponse =
	SuccessResponse<SetAttributeVocabularyValuesOrderResult>;

/**
 * `setAttributeVocabularyValuesOrder` result
 * (what is utilized from the server response)
 */
export type SetAttributeVocabularyValuesOrderResult = IAttributeVocabularyValue;

export const setAttributeVocabularyValuesOrderEndpoint =
	'setAttributeVocabularyValuesOrder';

/**
 * Set attribute vocabularies list
 * @param fetchParams Fetch params

 */
export const setAttributeVocabularyValuesOrder = async ({
	vocabularyId,
	sort,
}: SetAttributeVocabularyValuesOrderRequestOptions): Promise<SetAttributeVocabularyValuesOrderResult> => {
	const client = NetxQueryClient();

	const requestParams: SetAttributeVocabularyValuesOrderRequest = [
		vocabularyId,
		sort,
	];

	return client
		.post<SetAttributeVocabularyValuesOrderResponse>(
			setAttributeVocabularyValuesOrderEndpoint,
			requestParams,
			{},
		)
		.then(getResponseResults);
};

export default setAttributeVocabularyValuesOrder;
